import { ISort } from 'services/BackendApi';
import { ECrmDirectoryEntryType, ICrmPerson } from './DirectoryEntry';
import { IPagination } from 'store/common/types';

export enum ECrmActivityType {
  CALL = 'CALL',
  MEETING = 'MEETING',
  NOTE = 'NOTE',
  TASK = 'TASK',
}

export interface IActivityParticipantDirectoryEntry {
  /** Format: uuid */
  id: string;
  directoryEntryType: ECrmDirectoryEntryType;
  name: string;
  /** Format: email */
  email: string | null;
  relatedCompanyId: string;
  relatedCompanyName: string;
}

export interface ICrmActivityCategory {
  /** Format: uuid */
  id: string;
  name: string;
  group?: {
    id: string;
    name: string;
  };
}

export interface ICrmActivity {
  /** Format: uuid */
  id: string;
  type: ECrmActivityType;
  /** Format: date-time */
  date: string;
  title: string;
  description: string | null;
  participantDirectoryEntries: IActivityParticipantDirectoryEntry[];
  categories: ICrmActivityCategory[];
  beHumanReadableId: string | null;
  /** Format: date-time */
  createdDate: string;
  createdBy: ICrmPerson;
  /** Format: date-time */
  updatedDate: string | null;
  updatedBy: ICrmPerson;
  tmsTaskId: string;
}

export interface IUpsertActivityRequest {
  type: ECrmActivityType;
  /** Format: date-time */
  date: string;
  title: string;
  description: string | null;
  participantDirectoryEntryIds: string[];
  categoryIds: string[];
}

export interface ISearchActivityRequest {
  filter: {
    directoryEntryId?: string;
    types?: ECrmActivityType[];
    startDate?: string;
    endDate?: string;
    searchTerm?: string;
    createdById?: string;
  };
  sort?: ISort<'date'>;
  pagination: IPagination;
  cursor?: {
    limit: string; // uuid of an activity (according to crm endpoint api)
  }
}

export interface ISearchActivityResponse {
  pagination: IPagination;
  count: number;
  list: ICrmActivity[];
}

export interface ICrmActivityCategoryGroup {
  /** Format: uuid */
  id: string;
  name: string;
  categories: ICrmActivityCategory[];
}
